import request from '@/utils/request'

function list(path, params) {
  return request.get(`/health/${path}/list`, { params })
}

function create(path, data) {
  return request.post(`/health/${path}`, data)
}

function update(path, data) {
  return request.put(`/health/${path}`, data)
}

function remove(path, id) {
  return request.delete(`/health/${path}/${id}`)
}

export const athleteApi = {
  list: params => list('athlete', params),
  create: data => create('athlete', data),
  update: data => update('athlete', data),
  remove: id => remove('athlete', id)
}

export const dmwcApi = {
  list: params => list('dmwc', params),
  create: data => create('dmwc', data),
  update: data => update('dmwc', data),
  remove: id => remove('dmwc', id)
}

export const pbsqApi = {
  list: params => list('pbsq', params),
  create: data => create('pbsq', data),
  update: data => update('pbsq', data),
  remove: id => remove('pbsq', id)
}

export const adaptivePbsqApi = {
  list: params => list('adaptive-pbsq', params),
  remove: id => remove('adaptive-pbsq', id)
}

export const alertApi = {
  list: params => list('alert', params),
  create: data => create('alert', data),
  update: data => update('alert', data),
  remove: id => remove('alert', id)
}

export const nutritionApi = {
  list: params => list('nutrition', params),
  remove: id => remove('nutrition', id)
}

export const triageApi = {
  list: params => list('triage', params),
  remove: id => remove('triage', id)
}
